import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { BoydRewardsConnectComponent } from './boyd-rewards-connect.component';



@NgModule({
  declarations: [
    BoydRewardsConnectComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    BoydRewardsConnectComponent
  ]
})
export class BoydRewardsConnectModule { }
